<script setup lang="ts">
import type { Locale } from '@/settings/langs'
import { switchLocale } from '@/compositions/useLocale'
import { defaultLocale, languageSelectorEnabled, localeDisplayData, supportedLocales } from '@/settings/langs'

const route = useRoute()
const currentLocale = computed(() =>
  String(route?.meta?.pageData?.locale || route?.params?.locale || defaultLocale)
)

const sortedLocales = computed(() =>
  [...supportedLocales].sort((a, b) =>
    localeDisplayData[a as Locale].nativeName.localeCompare(
      localeDisplayData[b as Locale].nativeName
    )
  )
)

const columnCount = computed(() => Math.ceil(sortedLocales.value.length / 7))
const popoverWidth = computed(() => columnCount.value * 145)
</script>

<template>
  <template v-if="languageSelectorEnabled">
    <el-popover
      :show-arrow="false"
      :width="popoverWidth"
      popper-class="p-0 rounded-xl text-[18px]"
      placement="bottom-end"
    >
      <template #reference>
        <a class="block cursor-pointer py-1 border-0 normal-case whitespace-nowrap select-none">
          🌐 {{ currentLocale.toUpperCase() }}
          <icon-ify
            icon="bxs:chevron-down"
            class="inline"
          />
        </a>
      </template>
      <ul
        class="grid gap-x-2"
        :style="{ gridTemplateColumns: `repeat(${columnCount}, minmax(0, 1fr))` }"
      >
        <li
          v-for="locale in sortedLocales"
          :key="locale"
          class="cursor-pointer px-3 py-[3px] text-left border-b font-bold"
          :class="{ 'router-link-active': locale === currentLocale }"
          @click="switchLocale(locale as Locale)"
        >
          <span class="block py-1 w-full normal-case whitespace-nowrap">
            {{ localeDisplayData[locale as Locale]?.flag }}
            {{ localeDisplayData[locale as Locale]?.nativeName }}
          </span>
        </li>
      </ul>
    </el-popover>
  </template>
</template>
